import React from 'react';
import { components, SingleValueProps } from 'react-select';

import { DestinationOption } from '@lt/api/dist/methods/references/types';

export const SingleValue = (props: SingleValueProps<DestinationOption, false>) => {
  const { data } = props;

  return (
    <components.SingleValue {...props}>
      <span>{data.label || (data as any).destination.label}</span>
    </components.SingleValue>
  );
};
